// MapMonitoring/constants.ts

export const MAP_CENTER: [number, number] = [51.8272, 107.606];
export const MAP_ZOOM = 13;

export const CUSTOM_MARKS_STORAGE_KEY = "mapMonitoring_customMarks";
